module.exports = __webpack_public_path__ + "static/exterior-1-350ae7273b1dab1293d088896faf1247.jpg";